module.exports = __webpack_public_path__ + "img/class1.c1e55e96.png";